<mat-form-field>
  <mat-label>{{ control.label }}</mat-label>
  <mat-select [formControl]="control.formControls[0].formControl" [errorStateMatcher]="errorStateMatcher">
    @for (option of selectOptions; track option) {
    <mat-option [value]="option.value">{{ option.label }}</mat-option>
    }
  </mat-select>
  <!-- <mat-error class="warning">
  </mat-error> -->
</mat-form-field>